// BatteryFetcher.js
//
// Battery catalogue for all vendors (cdpcode/battery/contexts).
import CoreBase from '../../../services/engines/CoreBase';
import batteryContextService from '../../../services/BatteryContextService';

const _name = 'BatteryFetcher';

class BatteryFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches all known battery contexts.
     * @returns {Promise<object[]>}
     */
    fetch = async () => {
        try {
            const res = await batteryContextService.getContexts();
            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

export default new BatteryFetcher();
